<template>
    <div class="box d-flex flex-column justify-content-between">
        <div class="boxTitle d-flex justify-content-between">
            <div>
                <localized-text localizedKey="Portafoglio" text="Portafoglio"></localized-text>
            </div>
        </div>
        <template v-if="portafoglio">
            <doughnut-chart class="max-canvas-400 text-saldo"
                :value="[portafoglio.withdrawed, portafoglio.waiting, portafoglio.balance]" 
                :label="['Prelevato', 'In attesa', ' Saldo']" 
                :color="['#48dbab', '#f27a9a', '#c58700']"
                centerLabel="Saldo"
                :centerNumber="portafoglio.balance"
            ></doughnut-chart>
            <div class="portafoglioLower mt-3">
                <div class="portafoglioItem">
                    <div class="icon pagato"><img src="@/img/pagato.svg" /></div>
                    <div class="itemLabel">
                        <localized-text localizedKey="Pagato" text="Pagato"></localized-text> €
                    </div>
                    <div class="grosso">
                        {{portafoglio.withdrawed}}
                    </div>
                </div>
                <div class="portafoglioItem">
                    <div class="icon inAttesa"><img src="@/img/in_attesa.svg" /></div>
                    <div class="itemLabel">
                        <localized-text localizedKey="In attesa" text="In attesa"></localized-text> €
                    </div>
                    <div class="grosso">
                        {{portafoglio.waiting}}
                    </div>
                    <router-link :to="'/dashboard/commissions/' + user.identifier">
                        <localized-text localizedKey="Vedi" text="Vedi"></localized-text>
                    </router-link>
                </div>
                <div class="portafoglioItem">
                    <div class="icon saldo"><img src="@/img/saldo.svg" /></div>
                    <div class="itemLabel">
                        <localized-text localizedKey="Saldo" text="Saldo"></localized-text> €
                    </div>
                    <div class="grosso">
                        {{$filters.currency(portafoglio.total, 0)}}
                    </div>
                    <router-link :to="'/dashboard/walletTransactions/' + user.identifier">
                        <localized-text localizedKey="Vedi" text="Vedi"></localized-text>
                    </router-link>
                </div>
            </div>
            <hr />
            <div class="text-end">
                <template v-if="canRequestPaymentVm">
                    <template v-if="!canRequestPaymentVm.canRequest">
                        <div>
                            <localized-text localizedKey="Le richieste di pagamento vanno inserite <b>dal giorno {{dayFrom}} al giorno {{dayTo}} del mese </b>" 
                                text="Le richieste di pagamento vanno inserite <b>dal giorno {{dayFrom}} al giorno {{dayTo}} del mese </b>"
                                :object="{ dayFrom: canRequestPaymentVm.pagamentoRequestConfig.dayFrom, dayTo: canRequestPaymentVm.pagamentoRequestConfig.dayTo }"
                            ></localized-text>
                        </div>
                    </template>
                    <template v-else>
                        <button type="button" class="btn btn-primary" @click="richiediPagamentoModal" v-if="!pendingRequest">
                            <localized-text localizedKey="Richiedi pagamento" text="Richiedi pagamento"></localized-text>
                        </button>
                        <div class="text-end" v-else>
                            <div><b>
                                <localized-text localizedKey="Richiesta di pagamento inserita:" text="Richiesta di pagamento inserita:"></localized-text>
                            </b></div>
                            <div>
                                <localized-text localizedKey="Data ricevuta:" text="Data ricevuta:"></localized-text>
                                {{$filters.date(pendingRequest.date)}}
                            </div>
                            <div>
                                <localized-text localizedKey="Importo:" text="Importo:"></localized-text> 
                                {{$filters.currency(pendingRequest.amount)}} €
                            </div>
                            <div v-if="pendingRequest.allegato">
                                <a :href="pendingRequest.allegato.publicUrl" target="_blank">
                                    <localized-text localizedKey="Vedi allegato" text="Vedi allegato"></localized-text> 
                                </a>
                            </div>
                            <div>
                                <button type="button" class="btn btn-danger mt-2" @click="annullaRichiestaPagamento">
                                    <localized-text localizedKey="Annulla richiesta di pagamento" text="Annulla richiesta di pagamento"></localized-text> 
                                </button>
                            </div>
                        </div>
                    </template>
                </template>
            </div>
        </template>
    </div>
</template>

<script lang="ts">
import { Prop, Watch } from 'vue-property-decorator';
import * as OM from '@/model';
import * as CONST from '@/const';
import { Options, Vue } from 'vue-class-component';
import moment from 'moment';
import store from '@/store';
import RichiediPagamentoModal from './richiediPagamentoModal.vue';
import { checkIfRichiestaPagamentoPossible } from '@/utils';
import { DashboardClient, OperatorClient, ProjectConfigClient, UserPaymentRequestClient } from '@/services/Services';
import { ModalServices } from '@/services/ModalServices';
import { LocalizationServices } from '@/services/LocalizationServices';

@Options({})
export default class wallet extends Vue {

    @Prop() user: OM.PaymentUser;
    @Prop() reload;

    portafoglio: OM.DashboardPortafoglioVm  = null;

    canRequestPaymentVm: OM.CanRequestPaymentVm = null;
    
    pendingRequest: OM.UserPaymentRequest = null;

    created(){
        this.init();
    }

    @Watch('reload')
    onReload(next, prev){
        this.init();
    }
    
    init(){
        UserPaymentRequestClient.getPendingRequest(store.state.user.identifier)
        .then(x => {
            this.pendingRequest = x;
        })
        DashboardClient.getDashPortafoglio(this.user.identifier)
        .then( x => {
            this.portafoglio = x;
        });
    }

    richiediPagamentoModal(){
        if(!checkIfRichiestaPagamentoPossible(this.user)){
            ModalServices.alertModal(LocalizationServices.GetLocalizedValue("Attenzione", "Attenzione"), LocalizationServices.GetLocalizedValue("Completa i dati nel profilo per richiedere il pagamento", "Completa i dati nel profilo per richiedere il pagamento"));
            return;
        }
        // OperatorClient.getById(this.user.identifier)
        // .then(x => {
        //     x.authData.password = "";
        this.$opModal.show(RichiediPagamentoModal, {
            user: this.user,
        }, () => this.init());
        // })
    }
    annullaRichiestaPagamento(){
        if(!confirm("Confermi l'annullamento della richiesta?"))
            return;

        UserPaymentRequestClient.annullaRichiestaPagamento(this.pendingRequest.identifier)
        .then(x => {
            this.init();
        })
    }
    
}

</script>

<style scoped>

</style>